export const gradient = 'bg-gradient-to-r from-grStart via-grMid to-grEnd';
export const textGradient =
  'max-w-fit text-transparent bg-clip-text bg-gradient-to-r from-blueGr via-purpleGr to-yellowGr';
